var html = document.documentElement;
var body = document.body;

colorScheme();
menu();
mobileMenu();
postSlider();
infniteScroll();
copyToClipboard();

function colorScheme() {
  const isAuto = html.classList.contains('auto-color-scheme');
  
  if (isAuto && window.matchMedia('(prefers-color-scheme: dark)').matches) {
    html.classList.add('dark');
    const logos = document.querySelectorAll('.logo .is-auto.is-dark');
    logos.forEach((element) => {
      element.style.display = 'block';
    });
  } else {
    const logos = document.querySelectorAll('.logo .is-auto.is-light');
    logos.forEach((element) => {
      element.style.display = 'block';
    });
  }
}

function menu() {
  // Get the toggle-dropdown element
  const toggleDropdown = document.querySelector('.toggle-dropdown');
  
  if (toggleDropdown) {
    // Get the dropdown element
    const dropdown = document.querySelector('.dropdown');
    
    // Add a click event listener to toggle the dropdown
    toggleDropdown.addEventListener('click', () => {
      dropdown.classList.toggle('lg:hidden');
    });    
  }
}

function mobileMenu() {
  // Get the toggle-dropdown element
  const toggleNav = document.querySelector('.toggle-nav');

  if (toggleNav) {
    // Get the dropdown element
    const nav = document.querySelector('.nav');
    
    // Add a click event listener to toggle the dropdown
    toggleNav.addEventListener('click', () => {
      nav.classList.toggle('hidden');
    });
  }
}

function postSlider() {
  const sliders = document.querySelectorAll('.featured-section');
  
  sliders.forEach(function(slider) {
    const flktySlider = slider.querySelector('.featured-wrap'),
    flktyBtnPrevious = slider.querySelector('.featured-btn-previous'),
    flktyBtnNext = slider.querySelector('.featured-btn-next');
    
    if (flktySlider) {
      if (matchMedia('(min-width:1281px)').matches) {
        var flktyGroupCells = 1,
        flktySelectedAttraction = 0.025,
        flktyFriction = 0.38,
        flktyDragThreshold = 5
      } else {
        var flktyGroupCells = 1,
        flktySelectedAttraction = 0.2,
        flktyFriction = 0.8,
        flktyDragThreshold = 10
      }
      
      var flkty = new Flickity(flktySlider, {
        cellAlign: 'left',
        contain: true,
        groupCells: flktyGroupCells,
        prevNextButtons: false,
        pageDots: false,
        dragThreshold: flktyDragThreshold,
        selectedAttraction: flktySelectedAttraction,
        friction: flktyFriction,
        imagesLoaded: true
      });
      
      var flktyObserver = new IntersectionObserver(onIntersection, {
        root: null,
        threshold: 0
      })
      
      function onIntersection(entries, opts) {
        entries.forEach(entry =>
          entry.target.classList.toggle('is-visible', entry.isIntersecting)
          )
          if (flktySlider.querySelector('.is-visible')) {
            flktyBtnNext.classList.toggle("is-end");
          } else {
            flktyBtnNext.classList.remove("is-end");
          }
        }
        
        flktyObserver.observe(flktySlider.querySelector('.item .item-image .is-last'))
        
        flkty.on('change', function(index) {
          if (index > 0) {
            flktyBtnPrevious.classList.add("is-prev");
          } else {
            flktyBtnPrevious.classList.remove("is-prev");
          }
        });
        
        flktyBtnPrevious.addEventListener('click', function() {
          flkty.previous();
        });
        
        flktyBtnNext.addEventListener('click', function() {
          flkty.next();
        });
        
        /* iOS 12-14 fix */
        var tapArea,startX;for(var item of(tapArea=flktySlider.querySelectorAll(".featured-wrap"),startX=0,tapArea))item.ontouchstart=function(t){startX=t.touches[0].clientX},item.ontouchmove=function(t){Math.abs(t.touches[0].clientX-startX)>5&&t.cancelable&&t.preventDefault()};
      }
    });
  }

function infniteScroll() {
  const nextPage = document.getElementById('next');
  if (nextPage) {
    const container = nextPage.dataset.container;
    const items = nextPage.dataset.items;

    var infScroll = new InfiniteScroll('.'+container, {
      path: '#next',
      append: '.'+container+' .'+items,
      history: false,
      button: '#loadmore',
      hideNav: '#next',
      scrollThreshold: false
    });

    infScroll.on('append', function(response, path, items) {
      for (var i = 0; i < items.length; i++) {
        reloadSrcsetImgs(items[i]);
      }
    });

    function reloadSrcsetImgs(item) {
      var imgs = item.querySelectorAll('img[srcset]');
      for (var i = 0; i < imgs.length; i++) {
        var img = imgs[i];
        img.outerHTML = img.outerHTML;
      }
    }
  }
}

function copyToClipboard() {
  const copyButton = document.querySelector('.copy-to-clipboard');
  const copySuccess = document.querySelector('.copy-to-clipboard-success');

  if (copyButton) {
    copyButton.addEventListener('click', function(event) {
      event.preventDefault();

      const url = window.location.href;

      navigator.clipboard.writeText(url)
        .then(function() {
          copySuccess.classList.toggle('hidden');

          setTimeout(function() {
            copySuccess.classList.toggle('hidden');
          }, 3000)
        });
    });
  }
}
